{
  "jira-pandora.jira-project-access-granted.email.body.content.no-translate": [
    {
      "type": 0,
      "value": "You can now access "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "projectName"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "jira-pandora.jira-project-access-granted.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "jira-pandora.jira-project-access-granted.email.button.text.no-translate": [
    {
      "type": 0,
      "value": "View project"
    }
  ],
  "jira-pandora.jira-project-access-granted.email.footer.address.no-translate": [
    {
      "type": 0,
      "value": "341 George Street, Sydney, NSW, 2000, Australia"
    }
  ],
  "jira-pandora.jira-project-access-granted.email.footer.copyright.no-translate": [
    {
      "type": 0,
      "value": "Copyright 2025 Atlassian Pty Ltd. All rights reserved."
    }
  ],
  "jira-pandora.jira-project-access-granted.email.unsubscribe.text.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "jira-pandora.jira-project-access-granted.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "You've been granted access to "
    },
    {
      "type": 1,
      "value": "projectName"
    }
  ],
  "jira-pandora.jira-project-access-request-reminder.email.body.content.no-translate": [
    {
      "type": 0,
      "value": "Users have requested to join your Jira project"
    }
  ],
  "jira-pandora.jira-project-access-request-reminder.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "jira-pandora.jira-project-access-request-reminder.email.button.text.no-translate": [
    {
      "type": 0,
      "value": "View access requests"
    }
  ],
  "jira-pandora.jira-project-access-request-reminder.email.unsubscribe.text.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "jira-pandora.jira-project-access-request-reminder.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Access request for "
    },
    {
      "type": 1,
      "value": "projectName"
    }
  ],
  "jira.jira-notify-reaction.message-template.text.single-reaction-with-name": [
    {
      "type": 0,
      "value": ":bell: *"
    },
    {
      "type": 1,
      "value": "userName"
    },
    {
      "type": 0,
      "value": " reacted to your comment*"
    }
  ],
  "jira.jira-notify-reaction.message-template.text.view-comment": [
    {
      "type": 0,
      "value": "View comment"
    }
  ]
}